import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import MaintenanceGuard from './components/MaintenanceGuard';
import ComingSoon from './pages/ComingSoon';
import { CustomerProvider } from './context/CustomerContext';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { AdminProvider } from './context/AdminContext';
import { BlogProvider } from './context/BlogContext';

// Layout
import Header from 'components/layout/Header';
import Footer from 'components/layout/Footer';
import ScrollToTop from 'components/layout/ScrollToTop';

// Pages
import Home from 'pages/Home';
import Shop from 'pages/Shop';
import Account from 'pages/Account';
import ProductDetail from 'pages/ProductDetail';
import CuratedSelection from './pages/CuratedSelection';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderConfirmation from './pages/OrderConfirmation';
import NotFound from './pages/NotFound';
import WishlistPage from './pages/WishlistPage';
import Distribuidores from './pages/Distribuidores';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ActivateAccount from './pages/ActivateAccount';
import Unsubscribe from './pages/Unsubscribe';
import ReviewByToken from './pages/ReviewByToken';
import CotizarEnvio from './pages/CotizarEnvio';
import SociosDistribuidores from './pages/SociosDistribuidores';
import Contacto from './pages/Contacto';
import Diagnostico from './pages/Diagnostico';
import MiRutina from './pages/MiRutina';
import PartnerDashboard from './pages/PartnerDashboard';
import OrderDetail from './pages/OrderDetail';

// Content Pages
import PoliciesPage from './pages/PoliciesPage';
import NuestraHistoria from './pages/pages-templates/NuestraHistoria';
import Filosofia from './pages/pages-templates/Filosofia';
import Ingredientes from './pages/pages-templates/Ingredientes';
import Sostenibilidad from './pages/pages-templates/Sostenibilidad';

// Blog Pages
import BlogIndex from './pages/blog/BlogIndex';
import BlogArticle from './pages/blog/BlogArticle';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminProducts from './pages/admin/AdminProducts';
import AdminProductEdit from './pages/admin/AdminProductEdit';

// Admin Blog Pages
import AdminBlogLogin from './pages/adminblog/AdminBlogLogin';
import AdminBlogPosts from './pages/adminblog/AdminBlogPosts';
import AdminBlogEditor from './pages/adminblog/AdminBlogEditor';
import AdminBlogMedia from './pages/adminblog/AdminBlogMedia';
import AdminBlogSettings from './pages/adminblog/AdminBlogSettings';

function App() {
  return (
    <HelmetProvider>
    <MaintenanceGuard>
    <CustomerProvider>
    <CartProvider>
      <WishlistProvider>
      <BlogProvider>
      <AdminProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            {/* Admin Routes (sin Header/Footer) */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/products" element={<AdminProducts />} />
            <Route path="/admin/products/:id" element={<AdminProductEdit />} />

            {/* Admin Blog Routes (sin Header/Footer) */}
            <Route path="/adminblog" element={<AdminBlogLogin />} />
            <Route path="/adminblog/posts" element={<AdminBlogPosts />} />
            <Route path="/adminblog/edit/:id" element={<AdminBlogEditor />} />
            <Route path="/adminblog/media" element={<AdminBlogMedia />} />
            <Route path="/adminblog/settings" element={<AdminBlogSettings />} />

            {/* Public Routes (con Header/Footer) */}
            <Route path="/*" element={
              <div className="App min-h-screen" style={{ backgroundColor: "var(--phys-snow)", color: "var(--phys-ink)" }}>
                <Header />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/products/:productId" element={<ProductDetail />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/account/orders/:orderId" element={<OrderDetail />} />
                  <Route path="/socio" element={<PartnerDashboard />} />
                  <Route path="/curated-selection" element={<CuratedSelection />} />
                  <Route path="/wishlist" element={<WishlistPage />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/order-confirmation" element={<OrderConfirmation />} />
                  <Route path="/nuestra-historia" element={<NuestraHistoria />} />
                  <Route path="/filosofia" element={<Filosofia />} />
                  <Route path="/ingredientes" element={<Ingredientes />} />
                  <Route path="/sostenibilidad" element={<Sostenibilidad />} />
                  <Route path="/policies" element={<PoliciesPage />} />
                  <Route path="/distribuidores" element={<Distribuidores />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/activar-cuenta" element={<ActivateAccount />} />
                  <Route path="/baja" element={<Unsubscribe />} />
                  <Route path="/review/:token" element={<ReviewByToken />} />
                  <Route path="/cotizar-envio" element={<CotizarEnvio />} />
                  <Route path="/journal" element={<BlogIndex />} />
                  <Route path="/journal/:slug" element={<BlogArticle />} />
                  <Route path="/en-construccion" element={<ComingSoon />} />
                  <Route path="/socios-y-distribuidores" element={<SociosDistribuidores />} />
                  <Route path="/contacto" element={<Contacto />} />
                  <Route path="/diagnostico" element={<Diagnostico />} />
                  <Route path="/mi-rutina" element={<MiRutina />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
                <Footer />
              </div>
            } />
          </Routes>
        </Router>
      </AdminProvider>
      </BlogProvider>
      </WishlistProvider>
    </CartProvider>
    </CustomerProvider>
    </MaintenanceGuard>
    </HelmetProvider>
  );
}

export default App;
